import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Spinner } from "react-bootstrap";

class CasovaniDochazkaVypis extends Component {
  state = {};

  componentDidMount = () => {
    this.nactiDochazku();
  };

  componentDidUpdate = () => {
    const { idpobytu } = this.state;
    if (idpobytu && idpobytu !== this.props.idpobytu) {
      this.nactiDochazku();
    }
  };

  nactiDochazku = async () => {
    const { idpobytu } = this.props;
    const vypis = await httpService.post(
      config.apiEndpoint + "casovani/dochazkaVypisPobyt.php",
      { idpobytu }
    );
    this.setState({ loaded: true, vypis: vypis.data.vypis, idpobytu });
  };

  render() {
    const { vypis, loaded } = this.state;
    return (
      <React.Fragment>
        {loaded ? (
          vypis && vypis.length > 0 ? (
            <div className="row">
              <div className="col-md-2">
                <h4>{vypis && vypis[0].klient}</h4>
                <p>
                  <small>ID pobytu</small>
                  <br />
                  {vypis && vypis[0].idpobytu}
                  <br />
                  <small>Ubytování</small>
                  <br />
                  {vypis && vypis[0].ubytovani}
                </p>
              </div>
              <div className="col-md-10">
                <table className="table color-table primary-table">
                  <thead>
                    <tr>
                      <th>Den</th>
                      <th>Čas</th>
                      <th>Pracoviště</th>
                      <th>Procedura</th>
                      <th>Místnost</th>
                      <th>Stav</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vypis.map((v, index) => (
                      <tr key={index}>
                        <td>{v.den}</td>
                        <td>{v.cas_od}</td>
                        <td>{v.pracoviste}</td>
                        <td>{v.procedura}</td>
                        <td>{v.mistnost}</td>
                        <td>
                          {v.stav ? (
                            v.stav === "vcas" ? (
                              <span className="text-success">
                                Včasný příchod{" "}
                                <div style={{ fontSize: "0.8em" }}>
                                  {v.jmeno}
                                </div>
                              </span>
                            ) : v.stav === "pozde" ? (
                              <span className="text-warning">
                                Pozdní přídhod
                                <div style={{ fontSize: "0.8em" }}>
                                  {v.jmeno}
                                </div>
                              </span>
                            ) : v.stav === "vubec" ? (
                              <span className="text-danger">
                                Neúčast
                                <div style={{ fontSize: "0.8em" }}>
                                  {v.jmeno}
                                </div>
                              </span>
                            ) : (
                              <i>Neznámý stav</i>
                            )
                          ) : (
                            <i>Nepotvrzeno</i>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="alert alert-danger">Nic tu není...</div>
          )
        ) : (
          <div className="text-warning">
            <Spinner animation="grow" size="sm" variant="warning" />
            Loading...
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default CasovaniDochazkaVypis;
